import React, { useState } from "react";
import cloudStore from "../store/CloudStore";
import { Button, Grid, Paper, Typography } from "@material-ui/core";
import withIntl from "../utils/withIntl";
import { _post } from "../Api";
import { toast } from "react-toastify";
import { setMerchant } from "../store/CloudActions";
import CircularProgress from "@material-ui/core/CircularProgress";
import EditTextField from "../components/EditArticle/EditTextField";
import SelectArticles from "../components/Forms/SelectArticles";

function Woocommerce(props) {
  const [woocommerceMerchants, setWoocommerceMerchants] = useState(cloudStore.merchant.woocommerce_merchants);
  const [waitingForApiCall, setWaitingForApiCall] = useState(false);

  if (waitingForApiCall) {
    return (
      <div align="center">
        <CircularProgress color="primary" />
      </div>
    );
  }

  return (
    <>
      <Paper style={{ padding: 8 }}>
        <Typography variant={"h6"}>Woocommerce koppelingen</Typography>
        <Button
          variant={"contained"}
          color={"primary"}
          onClick={() => {
            updateWoocommerce({ merchant_id: cloudStore.merchant.id }).then((response) => {
              // takeawayMerchant.merchant_id = cloudStore.merchant.id;
              setWoocommerceMerchants(response);
            });
          }}
        >
          Create new connection
        </Button>
      </Paper>
      <Paper style={{ padding: 8 }}>
        {woocommerceMerchants.map((woocommerceMerchant) => (
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <Typography style={{ fontStyle: "italic" }}>Woocommerce koppeling</Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography style={{ fontStyle: "italic" }}>Installed: </Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography
                style={{
                  fontStyle: "italic",
                  color: woocommerceMerchant.webhook_order_created_installed ? "green" : "red",
                }}
              >
                {woocommerceMerchant.webhook_order_created_installed ? "Yes" : "No"}
              </Typography>
            </Grid>
            <Grid item xs={6}>
              Site url
            </Grid>
            <Grid item xs={6}>
              <EditTextField
                value={woocommerceMerchant.site_url ?? ""}
                onBlur={(value, setBeginValue) => {
                  updateWoocommerce({
                    woocommerce_merchant_id: woocommerceMerchant.id,
                    site_url: value === "" ? null : value,
                  }).then((merchant) => {
                    setWoocommerceMerchants(merchant);
                    setBeginValue(value === "" ? null : value);
                  });
                }}
              />
            </Grid>
            <Grid item xs={6}>
              Consumer key
            </Grid>
            <Grid item xs={6}>
              <EditTextField
                value={woocommerceMerchant.consumer_key ?? ""}
                onBlur={(value, setBeginValue) => {
                  updateWoocommerce({
                    woocommerce_merchant_id: woocommerceMerchant.id,
                    consumer_key: value === "" ? null : value,
                  }).then((merchant) => {
                    setWoocommerceMerchants(merchant);
                    setBeginValue(value === "" ? null : value);
                  });
                }}
              />
            </Grid>
            <Grid item xs={6}>
              Consumer secret
            </Grid>
            <Grid item xs={6}>
              <EditTextField
                value={woocommerceMerchant.consumer_secret ?? ""}
                onBlur={(value, setBeginValue) => {
                  updateWoocommerce({
                    woocommerce_merchant_id: woocommerceMerchant.id,
                    consumer_secret: value === "" ? null : value,
                  }).then((merchant) => {
                    setWoocommerceMerchants(merchant);
                    setBeginValue(value === "" ? null : value);
                  });
                }}
              />
            </Grid>

            <Grid item xs={12}>
              <Button
                variant={"contained"}
                color={"primary"}
                onClick={() => {
                  installWoocommerce(woocommerceMerchant).then((response) => {
                    setWoocommerceMerchants(response);
                  });
                }}
              >
                Install
              </Button>
            </Grid>

            {/*<Grid item xs={12}>*/}
            {/*  <FormControlLabel*/}
            {/*    control={*/}
            {/*      <Switch*/}
            {/*        color={"primary"}*/}
            {/*        checked={woocommerceMerchant.auto_confirm_orders}*/}
            {/*        onChange={(e) => {*/}
            {/*          updateWoocommerce({*/}
            {/*            woocommerce_merchant_id: woocommerceMerchant.id,*/}
            {/*            auto_confirm_orders: e.target.checked,*/}
            {/*          }).then((takeawayMerchant) => {*/}
            {/*            setWoocommerceMerchants(takeawayMerchant);*/}
            {/*          });*/}
            {/*        }}*/}
            {/*      />*/}
            {/*    }*/}
            {/*    label={"Automatically confirm orders"}*/}
            {/*  />*/}
            {/*</Grid>*/}

            <Grid item xs={6}>
              Fee product plu
            </Grid>
            <Grid item xs={6} container>
              <SelectArticles
                filteredOutArticles={[]}
                handleOnSelect={(article) => {
                  updateWoocommerce({
                    woocommerce_merchant_id: woocommerceMerchant.id,
                    fee_product_plu: article.plu,
                  }).then((merchant) => {
                    setWoocommerceMerchants(merchant);
                  });
                }}
                label={props.intl.formatMessage({ id: "select_article" })}
                value={woocommerceMerchant.fee_product_plu}
                helperText={props.intl.formatMessage({ id: "select_article" })}
              />
              {woocommerceMerchant.fee_product_plu != null && (
                <Button
                  variant={"outlined"}
                  onClick={() => {
                    updateWoocommerce({
                      woocommerce_merchant_id: woocommerceMerchant.id,
                      fee_product_plu: null,
                    }).then((merchant) => {
                      setWoocommerceMerchants(merchant);
                    });
                  }}
                >
                  Remove plu
                </Button>
              )}
            </Grid>
            <Grid item xs={6}>
              Coupon product plu
            </Grid>
            <Grid item xs={6} container>
              <SelectArticles
                filteredOutArticles={[]}
                handleOnSelect={(article) => {
                  updateWoocommerce({
                    woocommerce_merchant_id: woocommerceMerchant.id,
                    coupon_product_plu: article.plu,
                  }).then((merchant) => {
                    setWoocommerceMerchants(merchant);
                  });
                }}
                label={props.intl.formatMessage({ id: "select_article" })}
                value={woocommerceMerchant.coupon_product_plu}
                helperText={props.intl.formatMessage({ id: "select_article" })}
              />
              {woocommerceMerchant.coupon_product_plu != null && (
                <Button
                  variant={"outlined"}
                  onClick={() => {
                    updateWoocommerce({
                      woocommerce_merchant_id: woocommerceMerchant.id,
                      coupon_product_plu: null,
                    }).then((merchant) => {
                      setWoocommerceMerchants(merchant);
                    });
                  }}
                >
                  Remove plu
                </Button>
              )}
            </Grid>

            <Grid item xs={6}>
              Payment method prefix
            </Grid>
            <Grid item xs={6}>
              <EditTextField
                value={woocommerceMerchant.payment_method_prefix ?? ""}
                onBlur={(value, setBeginValue) => {
                  updateWoocommerce({
                    woocommerce_merchant_id: woocommerceMerchant.id,
                    payment_method_prefix: value === "" ? null : value,
                  }).then((merchant) => {
                    setWoocommerceMerchants(merchant);
                    setBeginValue(value === "" ? null : value);
                  });
                }}
              />
            </Grid>
            <Grid item xs={6}>
              Table id prefix
            </Grid>
            <Grid item xs={6}>
              <EditTextField
                value={woocommerceMerchant.table_id_prefix ?? ""}
                onBlur={(value, setBeginValue) => {
                  updateWoocommerce({
                    woocommerce_merchant_id: woocommerceMerchant.id,
                    table_id_prefix: value === "" ? null : value,
                  }).then((merchant) => {
                    setWoocommerceMerchants(merchant);
                    setBeginValue(value === "" ? null : value);
                  });
                }}
              />
            </Grid>
            <Grid item xs={6}>
              Unknown article plu
            </Grid>
            <Grid item xs={6} container>
              <SelectArticles
                filteredOutArticles={[]}
                handleOnSelect={(article) => {
                  updateWoocommerce({
                    woocommerce_merchant_id: woocommerceMerchant.id,
                    unknown_article_plu: article.plu,
                  }).then((merchant) => {
                    setWoocommerceMerchants(merchant);
                  });
                }}
                label={props.intl.formatMessage({ id: "select_article" })}
                value={woocommerceMerchant.unknown_article_plu}
                helperText={props.intl.formatMessage({ id: "select_article" })}
              />
              {woocommerceMerchant.unknown_article_plu != null && (
                <Button
                  variant={"outlined"}
                  onClick={() => {
                    updateWoocommerce({
                      woocommerce_merchant_id: woocommerceMerchant.id,
                      unknown_article_plu: null,
                    }).then((merchant) => {
                      setWoocommerceMerchants(merchant);
                    });
                  }}
                >
                  Remove plu
                </Button>
              )}
            </Grid>
            <Grid item xs={6}>
              Default vat for unlinked article (eg. 0.09 or 0.21 for respectively 9% or 21%)
            </Grid>
            <Grid item xs={6}>
              <EditTextField
                value={woocommerceMerchant.default_vat_articles ?? ""}
                onBlur={(value, setBeginValue) => {
                  updateWoocommerce({
                    woocommerce_merchant_id: woocommerceMerchant.id,
                    default_vat_articles: value === "" ? null : value,
                  }).then((merchant) => {
                    setWoocommerceMerchants(merchant);
                    setBeginValue(value === "" ? null : value);
                  });
                }}
              />
            </Grid>
          </Grid>
        ))}
      </Paper>
    </>
  );
}

function updateWoocommerce(woocommerceMerchant) {
  let data = { ...woocommerceMerchant };

  return _post(`/nova/v2/woocommerce_merchants/update`, [data])
    .catch((err) => {
      toast.error("Something went wrong.", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return Promise.reject();
    })
    .then((res) => {
      let updatedMerchant = { ...cloudStore.merchant };
      updatedMerchant.woocommerce_merchants = res.data;

      setMerchant(updatedMerchant);
      toast.success("Saved", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return Promise.resolve(res.data);
    });
}

function installWoocommerce(woocommerceMerchant) {
  return _post(`/nova/v2/woocommerce_merchants/install/${woocommerceMerchant.id}`)
    .catch((err) => {
      toast.error("Something went wrong.", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return Promise.reject();
    })
    .then((res) => {
      let updatedMerchant = { ...cloudStore.merchant };
      updatedMerchant.woocommerce_merchants = res.data;

      setMerchant(updatedMerchant);
      toast.success("Saved", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return Promise.resolve(res.data);
    });
}

export default withIntl(Woocommerce);
